import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';

/**
 * 発注ステータスの一括更新ユースケース
 */
export class UpdateOrderStatusUseCase {
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   * 発注ステータスの一括更新
   * @param orderIds - 発注ID
   * @param orderStatus - 発注ステータス
   */
  public async Execute(orderIds: string[], orderStatus: string): Promise<INetworkResult<string[], Error>> {
    try {
      const response = await this.repository.updateOrderStatus({
        putOrderInfo: {
          orderIds: orderIds,
          orderStatus: orderStatus,
        },
      });
      switch (response.status.type) {
        case 'success':
          break;
        case 'error':
          throw response.status.error;
        default:
          throw new Error('Invalid status');
      }

      // TODO: 2024/6/25 responseの型がバックエンドとopenapiで合っておらず、今はいらないのでコメントアウトしておく
      // const result = UpdateOrderAdapter.adaptForResponse(response.status.data);
      return {
        status: {
          type: 'success',
          data: [], // TODO: 2024/6/25 responseの型がバックエンドとopenapiで合っておらず、今はいらないのでコメントアウトしておく
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
